var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRussia = function SvgRussia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#russia_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M0 5.313h20v9.375H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M0 13.438h20v6.563H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M0 0h20v6.563H0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "russia_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#fff",
    rx: 2
  })))));
};
export { SvgRussia as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI2MDA0XzE0NTMyKSI+CjxyZWN0IHk9IjUuMzEyNSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjkuMzc1IiBmaWxsPSIjMDA1MkI0Ii8+CjxyZWN0IHk9IjEzLjQzNzUiIHdpZHRoPSIyMCIgaGVpZ2h0PSI2LjU2MjUiIGZpbGw9IiNEODAwMjciLz4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjYuNTYyNSIgZmlsbD0iI0VFRUVFRSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI2MDA0XzE0NTMyIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";